
export default {

    setLoading(state, loading) {
        state.loading = loading;
    },
    setList(state, list) {
        state.list = list;
    },

    setService(state, service) {
        state.service = service;
    },
    setServiceApi(state, api) {
        state.api = api;
    },

    setServiceTypes(state, types) {
        state.types = types;
    },
    setCurrentService(state, service) {
        state.currentService = service;
    }

}